import UFOSegment from '@atlaskit/react-ufo/segment';
import type AnalyticsWebClient from '@atlassiansox/analytics-web-client';
import { tenantType, userType } from '@atlassiansox/analytics-web-client';
import { useTenantData } from '@dev-agents/tenant-context';
import React, { createContext, useContext, useMemo } from 'react';

import { useAuthData } from '../../auth-context';
import { devAnalyticsClient } from '../client';

const AnalyticsWebClientContext = createContext<AnalyticsWebClient | undefined>(undefined);

export const AnalyticsWebClientProvider = ({ children }: { children: React.ReactNode }) => {
	const { tenantContexts } = useTenantData();
	const { user } = useAuthData();

	const analyticsWebClient = useMemo(() => {
		if (user?.accountId && tenantContexts[0].cloudId) {
			devAnalyticsClient.setTenantInfo(tenantType.CLOUD_ID, tenantContexts[0].cloudId);
			devAnalyticsClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, user.accountId);
			devAnalyticsClient.startUIViewedEvent();
		}

		return devAnalyticsClient;
	}, [user, tenantContexts]);

	return (
		<AnalyticsWebClientContext.Provider value={analyticsWebClient}>
			<UFOSegment name="devAgents.root">{children}</UFOSegment>
		</AnalyticsWebClientContext.Provider>
	);
};

export const useAnalyticsWebClient = (): AnalyticsWebClient => {
	const analyticsWebClient = useContext(AnalyticsWebClientContext);

	if (!analyticsWebClient) {
		throw new Error('Must be used inside AnalyticsWebClientProvider');
	}

	return analyticsWebClient;
};
